import { render, staticRenderFns } from "./newGeneral.vue?vue&type=template&id=45ce4a29&scoped=true&"
import script from "./newGeneral.vue?vue&type=script&lang=ts&"
export * from "./newGeneral.vue?vue&type=script&lang=ts&"
import style0 from "./newGeneral.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./newGeneral.vue?vue&type=style&index=1&id=45ce4a29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce4a29",
  null
  
)

export default component.exports